module.exports = __webpack_public_path__ + "img/urbi-02.e5c88811.jpg";